import page from 'page';
import renderNotfound from './renderNotfound';

export default function register() {
  page('*', (ctx, next) => {
    renderNotfound(ctx, next);
  });
}



// WEBPACK FOOTER //
// ./src/pages/notfound/notfound.js